import { render, staticRenderFns } from "./outdetail.vue?vue&type=template&id=1743be98&scoped=true&"
import script from "./outdetail.vue?vue&type=script&lang=js&"
export * from "./outdetail.vue?vue&type=script&lang=js&"
import style0 from "./outdetail.vue?vue&type=style&index=0&id=1743be98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1743be98",
  null
  
)

export default component.exports